import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import projectDetailsReducer from './slices/projectDetailsSlice';

const store = configureStore({
  reducer: {
    authVerification: userReducer,
    projectDetails: projectDetailsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;

